export enum ECacheKeys {
	FinanceCharges = 'FinanceCharges',
	Authentication = 'Authentication',
	Proposals = 'Proposals',
	Invoices = 'Invoices',
	Dashboard = 'Dashboard',
	Payments = 'Payments',
	ItemsLayout = 'ItemsLayout',
}
